import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function BackPage({ href }) {
  const navigate = useNavigate();

  const handleClick = () => navigate(href, { replace: true, state: { can_stay: true } })

  return (
    <div onClick={handleClick} className="flex flex-row justify-between items-center bg-white/30 border border-border px-4 py-2 rounded-md cursor-pointer hover:bg-[#ed3237]/50 hover:text-white">
      <ChevronLeft className="size-6" />
      <div>
        <p className="text-1xl font-semibold select-none">
          Voltar
        </p>
      </div>
      <div />
    </div>
  )
}